<template>
    <div class="comparisonblock" id="comparisonblock">
        <h6 class="mb-3">{{$t('ModernTheme.Comparelistings')}}</h6>
        <div class="row">
            <div class="col-lg-6 mb-3" v-for="assetItem in AssetComapreArray">
                <div class="compare-item">
                    <a href="javascript:;" class="remove-compare remove-icon" @click="RemoveCompareImage(assetItem)">
                        <i class="fa fa-trash-alt"></i>
                    </a>
                    <img :src="assetItem.ImagePaths[0].ImagePath" alt="Lakeridge" class="img-a img-fluid">
                </div>
            </div>
            <div class="col-lg-12 mb-3">
                <a href="#" class="btn btn-effect-3 theme-btn-1 w-100" @click="AssetCompare(AssetComapreArray)">{{$t('ModernTheme.Compare')}}</a>
            </div>
            <div class="col-lg-12 mb-3">
                <a href="#" class="btn btn-effect-3 btn-reset w-100" @click="CloseComparePopup">{{$t('ModernTheme.Close')}}</a>
            </div>
        </div>
        <button v-if="AssetComapreArray.length!=0" class="compare-property-label active" style="" @click="CollaspeComaprePopup">
            <span class="compare-count compare-label">{{AssetComapreArray.length}}</span>
            <i class="fa fa-trash-alt"></i>
        </button>
    </div>
</template>

<script>
    export default {
        name: "AssetComaprePopup",
        emits: ["CloseComparePopup", "SwitchToAssetCompareDetail", "RemoveCompareImage"],
        props: ["AssetComapreArray"],
        components: {
        },

        created() {
        },

        data() {

            return {
            }
        },

        methods: {
            AssetCompare(assetComapreArray) {
                this.$emit("SwitchToAssetCompareDetail", assetComapreArray);
            },
            CloseComparePopup() {
                this.$emit("CloseComparePopup");
            },
            RemoveCompareImage(assetItem) {
                this.$emit("RemoveCompareImage", assetItem);
            },

            CollaspeComaprePopup() {
                let compareElement = document.getElementById('comparisonblock');
                compareElement.classList.toggle('open')

            },

        },
    }
</script>
